export default "__VITE_PUBLIC_ASSET__cfb35c16__"